import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const LOGIN_URL = `${API_URL}/api/v1/login-new`;
export const FORGOT_PASSWORD_URL = `${API_URL}/api/v1/forgot-password`;
export const VERIFY_OTP_URL = `${API_URL}/api/v1/verify-otp-new`;
export const RESET_PWD_URL = `${API_URL}/api/v1/reset-password`;
export const SIGNUP_URL = `${API_URL}/api/v1/signup`;
export const VERIFY_EMAIL_URL = `${API_URL}/api/v1/verify-email`;
export const AGAIN_VERIFY_EMAIL_URL = `${API_URL}/api/v1/again-verify-email`;

export function login(payload) {
  return axios({
    url: LOGIN_URL,
    method: "POST",
    data: payload,
  });
}

export function verificationCode(email) {
  return axios({
    url: FORGOT_PASSWORD_URL,
    method: "POST",
    data: { email: email },
  });
}

export function verificationCodeSubmit(encryptedVerifyRequest) {
  return axios({
    url: VERIFY_OTP_URL,
    method: "POST",
    data: { encryptedVerifyRequest }
  });
}

export function resetPassword(token, password) {
  return axios({
    url: RESET_PWD_URL,
    method: "POST",
    data: { token, password },
  });
}

export function signup(payload) {
  return axios({
    url: SIGNUP_URL,
    method: "POST",
    data: payload,
  });
}

export function verifyEmail(payload) {
  return axios({
    url: VERIFY_EMAIL_URL,
    method: "POST",
    data: payload
  });
}

export function againVerifyEmail(email) {
  return axios({
    url: AGAIN_VERIFY_EMAIL_URL,
    method: "POST",
    data: { email },
  });
}
